import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';

const UserDashboard = () => {

  useAuth(); // Ensure the user is authenticated

  // Code start here

  // End
  
  return (
      <div className="add_user_wrapper min-height-600">
        <div className="container-fluid mt-3 p-4">
          <div className='row'>
            <div className='col-md-9'>
              <h4 className="blue add_user_heading">User Dashboard</h4>
            </div>
            <div className="col-md-3 align-right pb-3">
              
            </div>
          </div>
        </div>
      </div> 
  );
};

export default UserDashboard;
